export function IconRotate({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
    >
      <path
        fill="currentColor"
        d="M3.043 7.5c-1.302 2.249-1.504 4.513-.31 5.705a2.959 2.959 0 0 0 2.157.792c1.537 0 3.442-.802 5.174-2.25H7.44V10.25h4.498a.75.75 0 0 1 .75.75v4.498h-1.5v-2.732c-2 1.732-4.299 2.732-6.298 2.732a4.427 4.427 0 0 1-3.22-1.23C.476 13.076.134 11.271.703 9.184c.161-.58.375-1.144.64-1.684h1.7ZM10.99.503a4.425 4.425 0 0 1 3.218 1.23c1.192 1.191 1.534 2.996.964 5.082a9.768 9.768 0 0 1-.64 1.685h-1.696c1.302-2.25 1.504-4.514.31-5.706a2.96 2.96 0 0 0-2.156-.792c-1.537 0-3.442.802-5.174 2.249h2.624v1.5H3.94A.75.75 0 0 1 3.19 5V.503h1.5v2.731C6.69 1.502 8.989.503 10.989.503Z"
      />
    </svg>
  );
}
